import React from 'react'
import { connect } from "react-redux";
import BroadcastBannerTable from "./BroadcastBanner"

const GameBanner = () => {
  return (
    <BroadcastBannerTable bannerType={2} />
  )
}

export default connect(null, {  })(
  GameBanner
);

